<template>
    <div v-if="infoFetched && group">
        <div class="card mb-3">
            <div class="card-body">
                <h5 class="card-title">{{ group.group_name }}</h5>
                <p class="card-text">{{ group.address }}</p>
                <div class="row">
                    <div class="col-md-6">
                        <p class="card-text">{{ capitalize($t('users_exact')) }}</p>
                        <textarea readonly class="form-control scrollable-textarea" rows="6"
                            v-model="usersText"></textarea>
                    </div>
                    <div class="col-md-6">
                        <p class="card-text">{{ capitalize($t('devices_exact')) }}</p>
                        <textarea readonly class="form-control scrollable-textarea" rows="6"
                            v-model="devicesText"></textarea>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div v-else>
        <div class="card mb-3">
            <div class="card-body">
                <p class="card-text">{{ $t('select_to_see_info') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { capitalize } from '@/helpers';
import { fetchData } from '@/helpers';

export default {
    name: 'GroupCard',
    props: {
        group: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    computed: {
        usersText() {
            return this.users && Array.isArray(this.users) ? this.users.map(user => user.user_name).join('\n') : '';
        },
        devicesText() {
            return this.devices && Array.isArray(this.devices) ? this.devices.map(device => device.device_name +' ('+device.device_nickname+')').join('\n') : '';
        }
    },
    data() {
        return {
            infoFetched: false,
            users: [],
            devices: []
        }
    },
    watch: {
        group: {
            immediate: true,
            async handler(newGroup) {
                if (newGroup && newGroup.group_id && !this.infoFetched) {
                    const devices = await this.fetchData('devicegroups', { "group_id": newGroup.group_id });
                    if (devices) {
                        this.devices = devices;
                    }
                    const users = await this.fetchData('usergroups', { "group_id": newGroup.group_id });
                    if (users) {
                        this.users = users;
                    }
                    this.infoFetched = true;
                }
            }
        },
        key: {
            async handler() {
                //console.log('Key changed:', newVal);
                const devices = await this.fetchData('devicegroups', { "group_id": this.group.group_id });
                if (devices) {
                    this.devices = devices;
                }
                const users = await this.fetchData('usergroups', { "group_id": this.group.group_id });
                if (users) {
                    this.users = users;
                }
            }
        }
    },
    methods: {
        fetchData,
        capitalize
    }
}
</script>

<style scoped>
.scrollable-textarea {
    resize: none;
    /* Disable resizing */
    overflow-y: auto;
    /* Enable vertical scrolling */
}
</style>